import { render, staticRenderFns } from "./sophos.vue?vue&type=template&id=2fb6389e&scoped=true&"
import script from "./sophos.vue?vue&type=script&lang=js&"
export * from "./sophos.vue?vue&type=script&lang=js&"
import style0 from "./sophos.vue?vue&type=style&index=0&id=2fb6389e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb6389e",
  null
  
)

export default component.exports